import { render, staticRenderFns } from "./SelectedFilterItem.vue?vue&type=template&id=c09f20ec&scoped=true"
import script from "./SelectedFilterItem.vue?vue&type=script&lang=js"
export * from "./SelectedFilterItem.vue?vue&type=script&lang=js"
import style0 from "./SelectedFilterItem.vue?vue&type=style&index=0&id=c09f20ec&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c09f20ec",
  null
  
)

export default component.exports